const module = {
  routes: [
    {
      path: '/remote-objects',
      component: () => import('@/modules/remoteObjects/pages/index.vue'),
      children: [],
      meta: {
        layout: 'default',
        requiresAuth: true
      }
    }
  ]
};

export default module;
